const iconeData = {
  slug: "icon-e",
  name: "Honda ICON e:",

  hero: {
    shortDescription:
      "Motor listrik kompak Honda dengan desain ikonik, ringan, dan praktis untuk mobilitas urban",

    variants: [
      {
        key: "matte-black",
        label: "Iconic",
        fullName: "Honda ICON e Iconic Matte Black",
        startPrice: 28000000,
      },
      {
        key: "white",
        label: "Iconic",
        fullName: "Honda ICON e Iconic White",
        startPrice: 28000000,
      },
      {
        key: "mint",
        label: "Iconic",
        fullName: "Honda ICON e Iconic Mint",
        startPrice: 28000000,
      },
    ],

    slides: [
      {
        variantKey: "matte-black",
        image: "/assets/motor/produk/icone/ICON-e-Iconic-Matte-Black.webp",
        specs: {
          engine: "Motor Listrik (Hub Motor)",
          power: "1,8 kW (Peak Power)",
          smartKey: false,
        },
      },
      {
        variantKey: "white",
        image: "/assets/motor/produk/icone/ICON-e-Iconic-White.webp",
        specs: {
          engine: "Motor Listrik (Hub Motor)",
          power: "1,8 kW (Peak Power)",
          smartKey: false,
        },
      },
      {
        variantKey: "mint",
        image: "/assets/motor/produk/icone/ICON-e-Iconic-Mint.webp",
        specs: {
          engine: "Motor Listrik (Hub Motor)",
          power: "1,8 kW (Peak Power)",
          smartKey: false,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda ICON e: merupakan motor listrik entry-level Honda yang dirancang untuk mobilitas jarak dekat dengan desain ikonik dan pengoperasian yang mudah.",
      },
      {
        type: "paragraph",
        text:
          "Dengan bodi ringan dan motor listrik yang senyap, ICON e: cocok digunakan untuk aktivitas harian di area perkotaan.",
      },
      {
        type: "heading",
        text: "Desain Ikonik & Ringkas",
      },
      {
        type: "paragraph",
        text:
          "Desain minimalis dengan garis bodi bersih menjadikan Honda ICON e: tampil modern dan mudah dikendarai oleh berbagai kalangan.",
      },
      {
        type: "heading",
        text: "Ramah Lingkungan",
      },
      {
        type: "paragraph",
        text:
          "Menggunakan tenaga listrik tanpa emisi gas buang, Honda ICON e: mendukung gaya hidup ramah lingkungan.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Motor", "Motor Listrik (Hub Motor)"],
      ["Daya Maksimum", "1,8 kW"],
      ["Torsi Maksimum", "85 Nm"],
      ["Sistem Penggerak", "Direct Drive"],
    ],

    rangka: [
      ["Tipe Rangka", "Underbone"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Suspensi Belakang Tunggal"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Tromol"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.810 x 680 x 1.050 mm"],
      ["Tinggi Jok", "735 mm"],
      ["Jarak Sumbu Roda", "1.285 mm"],
      ["Berat", "±90 kg"],
    ],

    kapasitas: [
      ["Tipe Baterai", "Lithium-ion"],
      ["Kapasitas Baterai", "±1,3 kWh"],
    ],

    kelistrikan: [
      ["Sistem Starter", "Electric"],
      ["Panel Meter", "Full Digital"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda ICON e:",
    items: [
      {
        title: "Motor Listrik Senyap",
        desc:
          "Pengoperasian halus tanpa suara dan bebas emisi gas buang.",
      },
      {
        title: "Desain Ikonik",
        desc:
          "Tampilan simpel dan modern yang cocok untuk gaya hidup urban.",
      },
      {
        title: "Bobot Ringan",
        desc:
          "Mudah dikendalikan dan praktis untuk penggunaan harian.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Menampilkan informasi kecepatan dan status baterai secara jelas.",
      },
      {
        title: "Full LED Lighting",
        desc:
          "Lampu LED depan dan belakang untuk visibilitas optimal.",
      },
      {
        title: "Biaya Operasional Rendah",
        desc:
          "Efisiensi tinggi dengan perawatan yang minim.",
      },
    ],
  },
};

export default iconeData;
